const profile = {
  intro: `Seasoned Web Development and Digital Strategy Professional with over 15 years of experience leading teams and delivering innovative digital solutions across various industries, including e-commerce, fashion, real estate, and investment banking. Expert in modern web technologies and passionate about integrating code, design, and communication to enhance brand articulation and customer engagement.`
};

const experience = [
  {
    company: 'Bon Bebé',
    title: 'Director of eCommerce',
    period: 'July 2023 - October 2024',
    description: `Bon Bebé designs, produces, and distributes baby clothes and accessories under multiple brand-names. As Director of eCommerce my role was establishing an online direct to consumer retail presence for Bon Bebé's organic cotton brand Rabbit + Bear.`,
    logo: {
      src: '/logos/rnb.svg',
      alt: 'Rabbit + Bear',
      link: 'https://rabbitandbear.com'
    },
    achievements: [
      'Developed brand identity evolving Rabbit + Bear from just a name and a logo to a market ready brand',
      'Designed and coded Shopify storefront, email marketing flows, and campaigns; Designed posts and managed the Instagram account',
      'Organized and produced photo shoots, including casting models, story-boarding shots, and leading post-production',
      'Crafted product descriptions optimized for customer engagement, keyword ad spend, and organic search'
    ]
  },
  {
    company: 'Adjmi Apparel Group',
    title: 'Digital Director',
    period: 'July 2020 - May 2022',
    description: `Adjmi Apparel Group, located in the Garment District of Manhattan, designs, produces and distributes apparel to all tiers of retail. As Digital Director my central role was improving direct to consumer and marketplace brand performance.`,
    brands: [
      {
        name: 'Apana Yoga',
        logo: '/logos/apana-logo.png',
        link: 'https://amazon.com/apana',
        highlights: [
          'Refocused brand to fill the Yoga apparel sector in the Amazon catalog',
          'Products launched under my direction are greatly outperforming historical performance at Adjmi',
          'Ad spend is more efficient because of higher conversion rates per product listing view',
          'Listings are establishing themselves in category ranks'
        ],
        achievements: [
          'Organized & produced photo-shoots; casting models, story-boarding shots, lead post-production',
          'Developed product descriptions balancing customer persuasion, keyword ad spend, and organic amazon search',
          'Sharpened brand articulation and direction to lean into the Yoga space'
        ]
      },
      {
        name: 'Champion',
        logo: '/logos/champion-logo.png',
        link: 'https://www.amazon.com/s?i=merchant-items&me=A2A67I36WRS557&rh=p_4%3AChampion&dc&marketplaceID=ATVPDKIKX0DER',
        description: 'Helped manage Champion Kids apparel listings on Amazon',
        achievements: [
          'Refreshed graphic and product description listing content',
          'Creatively worked around limited photography and resources',
          'Increased page conversion rates and increased rankings'
        ]
      },
      {
        name: 'Copper Compression',
        logo: '/logos/copper-logo.png',
        link: 'https://coppercompression.com',
        highlights: [
          'Along with continuing web operations for Copper, I worked to transition the brand to get placement with major retailers',
          'Copper Compression is now in Walmart and Target in addition to other retailers'
        ],
        achievements: [
          'Rebuilt Gatsby website to work on Shopify Theme engine enabling growing team to contribute content updates to site',
          'Created a Photoshop automation workflow to efficiently create ad variations',
          'Completed Drew Brees endorsement project',
          'Created 3D packaging visualization pipeline to enhance pitches to major retailers'
        ]
      }
    ],
    corporate: {
      title: 'Adjmi Corporate',
      description: 'Along with the major brand responsibilities I also contributed to other projects within Adjmi',
      achievements: [
        'Built main corporate site (using Gatsby + Prismic) - adjmi.com',
        'Refreshed DTC channel for Adjmi in-house brand: layer8.com',
        'Created brand presence sites for Apana Yoga (apanalife.com) & Unipro (uniprosports.com)',
        'Created graphics production workflow to improve Amazon listings for various brands'
      ]
    }
  },
  {
    company: 'Ettio',
    title: 'Principal',
    period: 'March 2017 - July 2020',
    description: `While living in Brooklyn, New York I operated Ettio as a sole proprietorship, creating bespoke web deliverables for various clients. Delivered full stack solutions for customer facing clients. Worked with designers to create brand guidelines and then built the projects. Used variety of technologies, including Shopify, React, Gatsby, Prismic, Laravel.`,
    projects: [
      { name: 'GradeNYC', tech: 'Prismic CMS + Gatsby Frontend' },
      { name: 'Cherry Picks', tech: 'Wagtail CMS + React Frontend' },
      { name: 'Cadence', tech: 'Prismic CMS + React Frontend' },
      { name: 'Ironhound', tech: 'Laravel CMS + Vue Frontend' }
    ],
    clientLogos: [
      { src: '/logos/2_cadence.png', alt: 'Cadence Health', link: 'https://cadenceotc.com/' },
      { src: '/logos/2_cherryPicks.png', alt: 'The Cherry Picks', link: 'https://cherrypicks.com' },
      { src: '/logos/2_grade.png', alt: 'Grade New York', link: 'https://gradenewyork.com' },
      { src: '/logos/2_dte.png', alt: 'DTE Studio', link: 'https://dtestudio.com' },
      { src: '/logos/2_ironhound.png', alt: 'Ironhound', link: 'https://ironhound.com' },
      { src: '/logos/2_layer8.png', alt: 'Layer 8', link: 'https://layer8.com' }
    ],
    highlight: {
      project: 'CopperCompression.com',
      description: `Originally worked with CopperCompression.com to revamp their Shopify presence. The brand had just been acquired from an independent operator by Adjmi Apparel Group, they wanted to diversify the online sales as 98% of sales were through Amazon. When the Covid lock-down happened I pushed to continue operations and stepped up taking on almost every role. I approached it like my own startup.`,
      achievements: [
        'Because of my efforts we were able to win the mask scramble',
        'Brought over a million dollars of revenue in on the website for 3 straight months',
        'Created the 4th best performing single email on Klaviyo\'s platform for all of 2020 (https://www.klaviyo.com/blog/top-email-campaigns-examples)'
      ]
    }
  },
  {
    company: 'Williams New York',
    title: 'Digital Director',
    period: 'May 2014 - May 2017',
    description: `Located in the Soho neighborhood of New York City, Williams New York is a leading real estate branding & marketing firm. We worked for NYC's biggest developers and brokerages to create and implement brand identities for their properties.`,
    clientLogos: [
      { src: '/logos/3_alchemy.png', alt: 'Alchemy Properties' },
      { src: '/logos/3_extell.png', alt: 'Extell Development' },
      { src: '/logos/3_steiner.png', alt: 'Steiner Studios' },
      { src: '/logos/CIM.png', alt: 'CIM Group' },
      { src: '/logos/douglas-elliman.png', alt: 'Douglas Elliman' },
      { src: '/logos/fortis.png', alt: 'Fortis Property Group' },
      { src: '/logos/four-seasons.png', alt: 'Four Seasons' },
      { src: '/logos/houlihan.png', alt: 'Houlihan Lawrence' },
      { src: '/logos/spruce.png', alt: 'Spruce Capital Partners' }
    ],
    responsibilities: `As Digital Director I worked with department heads and clients to create unique digital experiences online and in sales offices. On each project I worked with the account manager to schedule milestones that fit their project and my team's capacity. Coordinated with other departments (3d renders, video, photography, copywriting) to procure the various media needed for our web deliverables.

Worked to maintain a workflow where each site could be designed and built to look completely bespoke, while still identifying and developing key common features (such as real estate availability). When designers were able to work directly with developers early on in process, the creative exploration of cutting edge front-end techniques led to beautiful innovative sites that stayed within technical feasibility and budgetary scope.`,
    achievements: [
      'Managed up to 8 concurrent active projects from conception through completion',
      'Hired and developed team as project workload increased',
      'Led team of 3-6 developers and designers',
      'Created in-house real estate focused backend CMS with api integration to NYC real estate databases (Laravel + Vue)',
      'Represented web department at client meetings'
    ],
    sampleProjects: [
      { name: 'Seaport Residences', link: 'https://seaportresidencesnyc.com/' },
      { name: 'One 57', link: 'https://one57.com/' }
    ]
  },
  {
    company: 'Ettio',
    title: 'Principal',
    period: 'January 2012 - May 2014',
    description: `Created a company to provide my web development design and development services on a consulting basis. Designed and built full stack web deliverables using CodeIgniter or Laravel, jQuery, and Bootstrap.

Continued working with real estate projects while branching into other sectors including investment banking and social organizations. Highlights included Pach.org, Tag Asia Partners, and 135 West 52nd Street.`
  },
  {
    company: 'The 7th Art',
    title: 'Senior Web Developer',
    period: 'April 2009 - December 2011',
    description: `Located in Soho New York, The 7th Art was a brand and marketing agency focused on luxury real estate and related markets. Served as lead web developer as well as liaison between account managers and designers.`,
    achievements: [
      'Worked with Account Managers and Designers to find opportunities for elevated web experiences',
      'Built dozens of web projects including:',
      'Creating ThePlaza.com',
      'Creating AlignedNYC database driven real estate listings site'
    ],
    clientLogos: [
      { src: '/logos/3_plaza.png', alt: 'The Plaza' },
      { src: '/logos/3_jbgSmith.png', alt: 'JBG Smith' },
      { src: '/logos/3_lenfant.png', alt: 'L\'Enfant Plaza' }
    ],
    background: `Started role helping company transition from flash technology to html5 websites. Led team in creation of subsequent web projects. Used myriad deliverables as opportunities to advance my technical skills, becoming an expert in Html, CSS, JavaScript, and PHP.`
  }
];

const skills = {
  technical: [
    'HTML',
    'CSS',
    'Tailwind',
    'React',
    'Gatsby',
    'Laravel',
    'Shopify',
    'PHP',
    'JavaScript',
    'Node',
    'Adobe Creative Suite'
  ],
  professional: [
    'Team Building',
    'Client Management',
    'Project Scheduling',
    'Budgeting & Management',
    'Creative Direction',
    'Production Supervision',
    'Digital Concepts',
    'Web Development',
    'Digital Design',
    'Branding',
    'Marketing',
    '3D Rendering',
    'Motion Graphics',
    'Animation'
  ]
};

const education = {
  university: 'Northeastern University, Boston, MA',
  preparatory: 'Northfield Mount Hermon, Northfield, MA'
};

const contact = {
  name: 'Benjamin Lundquist',
  email: 'benjamin@ettio.com',
  phone: '551-388-6763',
  downloadText: 'Save my resume as a PDF'
};

const navigation = {
  sections: [
    'Profile',
    'Experience',
    'Skills',
    'Contact'
  ]
};

export { 
  profile, 
  experience, 
  skills, 
  education, 
  contact, 
  navigation 
};